import { CatalogItemViewModel } from '@common/model/catalog/item/view';
import { GeoPoint } from '@youhelp-ru/core';
import { GeoPointDTO } from '@common/model/location/geopointDTO';

export const getResumeGeoPoint = (model: CatalogItemViewModel): GeoPoint | undefined => {
  let location: GeoPointDTO | undefined;

  if (model.location) {
    location = model.location;
  } else if (model.clientProfile && model.clientProfile.location) {
    location = model.clientProfile.location;
  } else if (model.city) {
    location = model.city.centerPoint;
  }
  if (!location) {
    return;
  }
  if (!GeoPoint.canParse(location)) {
    return GeoPoint.parse('geo:' + location);
  }
  return GeoPoint.parse(location);
};
